export const leftNavData = [{
        index: 'Home',
        name: '首\u2003\u2003页',
        icon: require('@assets/imgs/left-nav-icon/home2.png'),
        iconed: require('@assets/imgs/left-nav-icon/home-active2.png'),
        isShow: true, // 是否显示
        isActive: true,
        isRouter: true,
        isClick: true,
    }, {
        index: 'BasicData',
        name: '基础数据',
        icon: require('@assets/imgs/left-nav-icon/basicsData2.png'),
        iconed: require('@assets/imgs/left-nav-icon/basicsData-active2.png'),
        isShow: true, // 是否显示
        isActive: false,
        isRouter: true,
        isClick: false,
        childe: [
            {
                index: 'play',
                name: '景点景区',
                repor_type: 1,
                isShow: true, // 是否显示
            }, {
                index: 'stay',
                name: '酒店住宿',
                repor_type: 2,
                isShow: true, // 是否显示      
            },
            {
                index: 'restaurant',
                name: '美食餐饮',
                repor_type: 3,
                isShow: true, // 是否显示
            }, {
                index: 'amuse',
                name: '休闲娱乐',
                repor_type: 4,
                isShow: true, // 是否显示
            },
            {
                index: 'shop',
                name: '消费购物',
                repor_type: 5,
                isShow: true, // 是否显示
            },
            {
                index: 'alarm',
                name: '求助点',
                repor_type: 6,
                isShow: true, // 是否显示
            },
            {
                index: 'inquirypoint',
                name: '咨询点',
                repor_type: 7,
                isShow: true, // 是否显示
            },
            {
                index: 'traffic',
                name: '公共交通',
                repor_type: 8,
                isShow: true, // 是否显示
            },
            {
                index: 'servicepoint',
                name: '游客中心',
                repor_type: 9,
                isShow: true, // 是否显示
            },
            {
                index: 'toilet',
                name: '公共厕所',
                repor_type: 10,
                isShow: true, // 是否显示
            },
            {
                index: 'activity',
                name: '旅游活动',
                repor_type: 11,
                isShow: true, // 是否显示
            },
            {
                index: 'travel_line',
                name: '线路推荐',
                repor_type: 12,
                isShow: true, // 是否显示
            },
            {
                index: 'employees',
                name: '从业人员',
                repor_type: 13,
                isShow: true, // 是否显示
            },
            {
                index: 'carpark',
                name: '停车场',
                repor_type: 14,
                isShow: true, // 是否显示
            },
        ]
    }, {
        index: 'lineplan',
        name: '线路规划',
        icon: require('@assets/imgs/left-nav-icon/line2.png'),
        iconed: require('@assets/imgs/left-nav-icon/line-active2.png'),
        isShow: true, // 是否显示
        isActive: false,
        isRouter: false,
        isClick: false,
        active: false,
    }, {
        index: 'media',
        name: '媒体管理',
        icon: require('@assets/imgs/left-nav-icon/media2.png'),
        iconed: require('@assets/imgs/left-nav-icon/media-active2.png'),
        isShow: true, // 是否显示
        isActive: false,
        isRouter: true,
        isClick: false,
        active: false,
    
    },
    {
        index: 'voiceguide_qrcode',
        name: '二维码管理',
        icon: require('@assets/imgs/left-nav-icon/code2.png'),
        iconed: require('@assets/imgs/left-nav-icon/code-active2.png'),
        isShow: true, // 是否显示
        isActive: false,
        isRouter: true,
        isClick: false,
        active: false,
    },
    {
        index: 'SystemConfig',
        name: '系统配置',
        icon: 'el-icon-setting',
        icon: require('@assets/imgs/left-nav-icon/config2.png'),
        iconed: require('@assets/imgs/left-nav-icon/config-active2.png'),
        isShow: true, // 是否显示
        isActive: false,
        isRouter: true,
        isClick: false,
        active: false,
        childe: [
            {
                index: 'ColumnConfig',
                name: '栏目配置',
                repor_type: 1,
                isShow: true, // 是否显示
                isRouter:true,
            },{
                index: 'ParamsConfig',
                name: '参数配置',
                repor_type: 5,
                isShow: true, // 是否显示
                isRouter:true,
            },
            {
                index: 'AccountManage',
                name: '账户管理',
                repor_type: 2,
                isShow: true, // 是否显示
                isRouter:true,
            },
            {
                index: 'RoleManage',
                name: '角色管理',
                repor_type: 3,
                isShow: true, // 是否显示
                isRouter:true,
            },
            {
                index: 'DepartmentManage',
                name: '部门管理',
                repor_type: 4,
                isShow: true, // 是否显示
                isRouter:true,
            },
            
        ]
    },
   


]